import {FormsModule, ReactiveFormsModule } from "@angular/forms";
import {CommonModule} from "@angular/common";
import { SearchResultsComponent } from "src/app/Tests/search-results/search-results.component";
import {TestListComponent} from "../../Tests/test-list/test-list.component";
import { AllTestsComponent } from "src/app/Tests/all-tests/all-tests.component";
import {NgModule} from "@angular/core";
import { CategoryComponent } from "src/app/Tests/category/category.component";
import { ProductComponent } from "src/app/Tests/product/product.component";
import {CatalogRoutingModule} from "./catalog-routing.module";
import { MatExpansionModule } from "@angular/material/expansion";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import {CatalogRouterComponent} from "./catalog-router.component";

@NgModule({
  declarations: [
    AllTestsComponent,
    CategoryComponent,
    ProductComponent,
    SearchResultsComponent,
    CatalogRouterComponent
  ],
  imports: [
    CommonModule,
    CatalogRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatExpansionModule,
    NgbModule
  ]
})
export class CatalogModule { }
